import {SagaIterator} from 'redux-saga';
import {put, select} from 'typed-redux-saga';

import {CabBreedingFemale} from 'api/gen/CabBreedingFemale';
import {firstPageTableDataRequest} from 'utils/tables';

import {animalBrowserAction} from '../action';
import {simpleAnimalBrowserSelector} from '../selector';

/**
 * Updates the comprehensive breeding-female session state after filtering.
 *
 * @param isFull Indicates whether the current filter returned a full session result.
 * @param firstTime Marks the first successful load of the comprehensive view.
 * @returns The follow-up saga effects that preserve session state consistency.
 */
export function* updateCabFemalesSessionAfterFilter(
    isFull: boolean,
    firstTime?: 'FIRST_LOAD',
): SagaIterator {
    const previousCountEmpty = (yield* select(simpleAnimalBrowserSelector.isCabFemalesSessionEmpty));
    if (firstTime) {
        yield* put(animalBrowserAction.firstBreedingFemaleLoad(firstTime));
    } else if (isFull && !previousCountEmpty) {
        // Filtering replaces the session contents, so the previously selected page may no longer exist.
        yield* put(animalBrowserAction.getCabFemales(firstPageTableDataRequest<CabBreedingFemale>()));
    }
    yield* put(animalBrowserAction.setCabFemalesExistInSession(isFull));
}
